import React from "react";

const ContactInfo = () => {

    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
        <div className="ltn__contact-address-area mb-90">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow personalized">
                            <div className="ltn__contact-address-icon">
                                <img
                                    src={`${publicUrl}assets/img/icons/10.png`}
                                    alt="Icône"
                                />
                            </div>
                            <h3>Adresse e-mail</h3>
                            <p>conatct@terganeteranga.com</p>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow personalized">
                            <div className="ltn__contact-address-icon">
                                <img
                                    src={`${publicUrl}assets/img/icons/11.png`}
                                    alt="Icône"
                                    />
                            </div>
                            <h3>Numéro de téléphone</h3>
                            <p>(+221) 77 034 56 87</p>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow personalized">
                            <div className="ltn__contact-address-icon">
                                <img
                                    src={`${publicUrl}assets/img/icons/12.png`}
                                    alt="Icône"
                                />
                            </div>
                            <h3>Adresse du bureau</h3>
                            <p>VDN, Lot 67, Bande Verte Échangeur</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactInfo;
